<script setup>
import { ref } from 'vue';
import ModalItemsPublicos from '../../apps/panel_evaluacion/ModalItemsPublicos.vue';

const props = defineProps({
  icon: { type: String, required: false, default: 'fa fa-chart-bar' },
  alumnoId: { type: Number, required: true },
  evaluacionId: { type: Number, required: true },
  asignaturaId: { type: Number, required: true },
  grupoId: { type: Number, default: null },
  cuadernoId: { type: Number, default: null },
  mostrarVisiblesTutor: { type: Boolean, default: false },
  mostrarVisiblesFamilia: { type: Boolean, default: true },
});

const modalItemsPublicos = ref(null);

function mostrarItemsPublicosAlumno() {
  modalItemsPublicos.value.show(
    props.alumnoId,
    props.grupoId,
    props.evaluacionId,
    props.asignaturaId,
    {
      idCuaderno: props.cuadernoId,
      mostrarVisiblesTutor: props.mostrarVisiblesTutor,
      mostrarVisiblesFamilia: props.mostrarVisiblesFamilia,
    },
  );
}
</script>

<template>
  <a href="#" v-bind="$attrs" @click.prevent="mostrarItemsPublicosAlumno">
    <i :class="props.icon"></i>
  </a>
  <ModalItemsPublicos ref="modalItemsPublicos" />
</template>
